
import Slice9Panel from "../../../../../../../shared/lib/html5-software-library/src/ranj/components/scale9/Slice9Panel";
import TextTypeWriterAnimation from "../../../../../../../shared/src/ranj/app/ui/animation/typewriters/TextTypeWriterAnimation";
import BalloonView from "./BalloonView";

export default class InfoBalloonView extends BalloonView {

    constructor(target) {
        super(target);

        const bitmap = target.bg.children.find(c => c instanceof createjs.Bitmap);
        this._slice9Panel = new Slice9Panel(target, bitmap, { mode: Slice9Panel.VERTICAL, pixelPerfect: true, overlap: false, cacheBitmap: true });
    }

    setText(text, animate) {
        if (this._textAnim) {
            this._textAnim.forceFinish();
        }

        if (animate) {
            this._fadeIn(this._target);
        }

        this._textfield.text = text;
        this._slice9Panel.update();

        this._textAnim = this._animateTextIn(this._textfield, text);
    }

    getTextHeight() {
        return this._textfield.getMeasuredHeight();//* this._textfield.scaleY;
    }

    _fadeIn(target) {
        target.alpha = 0;
        const duration = 300 / this._speedFactor;
        createjs.Tween.get(target).to({ alpha: 1 }, duration, createjs.Ease.quadOut);
    }

    _animateTextIn(textField, text) {
        const charactersPerSecond = 80;
        const typeWriterDuration = text.length / charactersPerSecond / this._speedFactor;
        return TextTypeWriterAnimation.animate(textField, text, typeWriterDuration, 0, createjs.Ease.linear);
    }
}
